<template>
    <a v-if="$store.state.isApp" @click.prevent="openUrl()">
        <slot></slot>
    </a>

    <a v-else :href="href" target="_blank">
        <slot></slot>
    </a>
</template>

<script>
    export default {
        props: {
            href: String,
        },
        methods: {
            openUrl() {
                return window.open(this.href, '_system', 'location=yes');
                // if (this.href.indexOf("://") == -1) {
                //   // this.href = "https://" + this.href;
                // }
                // if (document.body.classList.contains("app")) {
                //   // navigator.app.loadUrl(this.href, { openExternal: true });
                // } else {
                //   // console.log('url',this.href);
                //   // console.log('url',this.href.indexOf("://"));
                //   // window.open(this.href, "_blank");
                // }
            }
        }
    };
</script>
